import { render } from "./AjoutTuteur.vue?vue&type=template&id=fede968a"
import script from "./AjoutTuteur.vue?vue&type=script&lang=js"
export * from "./AjoutTuteur.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/AjoutTuteur.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fede968a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fede968a', __exports__)) {
    console.log('reload')
    api.reload('fede968a', __exports__)
  }
  
  module.hot.accept("./AjoutTuteur.vue?vue&type=template&id=fede968a", () => {
    console.log('re-render')
    api.rerender('fede968a', render)
  })

}


export default __exports__